import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { SectionFieldRow } from "./SectionFieldRow";
import { useDebouncedInput, parseNullableNumber } from "./useDebouncedInput";

interface RoundsFieldProps {
  value: number | null;
  onChange: (value: number | null) => void;
}

export function RoundsField(props: RoundsFieldProps) {
  const { t } = useTranslation();
  const { localValue, handleChange } = useDebouncedInput({
    initialValue: props.value,
    onChange: props.onChange,
    transform: parseNullableNumber,
  });

  return (
    <SectionFieldRow
      label={t("editWorkout.rounds")}
      renderField={(id) => {
        return (
          <Input
            id={id}
            type="number"
            min={1}
            value={localValue}
            onChange={handleChange}
            className="h-7 w-14 text-sm bg-white/80 border-slate-200 px-2"
            placeholder="0"
          />
        );
      }}
    />
  );
}
